export const EMOTION_CACHE_KEY = "rp";
